import React from 'react';

export function SkeletonLine({ width = '100%', height = '20px', className = '' }) {
  return (
    <div
      className={`skeleton rounded-lg ${className}`}
      style={{ width, height }}
    />
  );
}

export function SkeletonCard() {
  return (
    <div className="modern-card animate-pulse">
      <SkeletonLine height="24px" width="60%" className="mb-4" />
      <SkeletonLine height="16px" width="100%" className="mb-2" />
      <SkeletonLine height="16px" width="90%" className="mb-2" />
      <SkeletonLine height="16px" width="80%" />
    </div>
  );
}

export function AnalysisLoadingState() {
  return (
    <div className="max-w-4xl mx-auto px-6 mb-6 animate-fade-in">
      <div className="modern-card">
        {/* Header */}
        <div className="flex items-center space-x-3 mb-6">
          <div className="w-12 h-12 skeleton rounded-2xl" />
          <div className="flex-1">
            <SkeletonLine height="20px" width="150px" className="mb-2" />
            <SkeletonLine height="14px" width="200px" />
          </div>
        </div>

        {/* Content */}
        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="bg-stone-50 rounded-2xl p-4">
              <div className="flex items-center justify-between mb-3">
                <SkeletonLine height="18px" width="100px" />
                <SkeletonLine height="24px" width="80px" />
              </div>
              <SkeletonLine height="40px" width="100%" className="mb-3" />
              <div className="space-y-2">
                <SkeletonLine height="16px" width="100%" />
                <SkeletonLine height="16px" width="90%" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function ProgressLoader({ progress = 0, message = 'Memproses...' }) {
  return (
    <div className="max-w-4xl mx-auto px-6 mb-6 animate-fade-in">
      <div className="modern-card text-center py-12">
        {/* Animated Icon */}
        <div className="relative w-24 h-24 mx-auto mb-6">
          <div className="absolute inset-0 bg-gradient-to-br from-green-400 to-green-600 rounded-full animate-pulse" />
          <div className="absolute inset-2 bg-white rounded-full flex items-center justify-center">
            <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin" />
          </div>
        </div>

        {/* Message */}
        <h3 className="text-lg font-bold text-stone-800 mb-2">
          {message}
        </h3>
        <p className="text-sm text-stone-500 mb-6">
          Sedang menganalisis teks Arab Anda...
        </p>

        {/* Progress Bar */}
        <div className="max-w-xs mx-auto">
          <div className="h-2 bg-stone-100 rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-green-400 to-green-600 transition-all duration-300 ease-out"
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className="text-xs text-stone-400 mt-2">
            {progress}%
          </p>
        </div>
      </div>
    </div>
  );
}

export default function LoadingState({ type = 'skeleton', progress, message }) {
  switch (type) {
    case 'progress':
      return <ProgressLoader progress={progress} message={message} />;
    case 'analysis':
      return <AnalysisLoadingState />;
    case 'skeleton':
    default:
      return <SkeletonCard />;
  }
}